import { Component, OnInit, Inject, HostListener, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'app-scroll-top',
	templateUrl: './scroll-top.component.html',
	styleUrls: ['./scroll-top.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ScrollTopComponent {
	windowScrolled: boolean;
	topOffset: number = 250; // Top offset to display scroll to top button

	constructor(@Inject(DOCUMENT) private document: Document) {}

	@HostListener('window:scroll', [])
	onWindowScroll() {
		if (
			window.pageYOffset > this.topOffset ||
			document.documentElement.scrollTop > this.topOffset ||
			document.body.scrollTop > this.topOffset
		) {
			this.windowScrolled = true;
		} else if ((this.windowScrolled && window.pageYOffset) || document.documentElement.scrollTop || document.body.scrollTop < 10) {
			this.windowScrolled = false;
		}
	}

	scrollToTop() {
		window.scrollTo(0, 0);
	}
}
